import React from "react";
import "./css/cartPage.css";

const CartPage = () => {
  return <div id="cart_page" className="page"></div>;
};

export default CartPage;
